import { Component, Injector } from '@angular/core';
import { NavController, LoadingController, NavParams, ViewController } from 'ionic-angular';
import { Util } from '../../app/util';
@Component({
  selector: 'page-credits',
  templateUrl: 'credits.html'
})
export class CreditsPage extends Util { 
  html : string = "";
  titolo : string = "Info";
  constructor(public navCtrl: NavController, injector: Injector, loadingCrtl: LoadingController, public navparams: NavParams, public viewCrtl:ViewController) {
    super(injector, loadingCrtl)
    
    this.html = this.navparams.get('content');
    this.titolo = this.navparams.get('titolo');
  }

  
  chiudi() {
    this.viewCrtl.dismiss();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/credits/credits.ts